import { configureStore } from '@reduxjs/toolkit';

import { keycloakApi } from '@/api/keycloak';
import { calizaApi } from '@/api/v1';
import authReducer, { AuthState } from '@/StateManagement/AuthReducer';

export interface ApplicationState {
  readonly auth: AuthState;
}

export const store = configureStore<ApplicationState>({
  reducer: {
    auth: authReducer,
    [calizaApi.reducerPath]: calizaApi.reducer,
    [keycloakApi.reducerPath]: keycloakApi.reducer,
  },
  // WARNING: These `any` here are because redux people think you're crazy
  //          to specify types explicitly everywhere.
  middleware: (getDefaultMiddleware: any): any =>
    getDefaultMiddleware().concat(calizaApi.middleware, keycloakApi.middleware),
});
